import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import { useMessageInputContext } from 'stream-chat-react';
import React from 'react';

export const CustomEmojiPicker = () => {
  const { onSelectEmoji } = useMessageInputContext();

  return (
    <div className="wrapper">
      <Picker onSelect={onSelectEmoji} />
    </div>
  );
};
